import React, { useState } from 'react';
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '@/components/ui/drawer';
import { Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';
import LeftSidebar from '@/js/components/sidebars/LeftSidebar';
import SidebarSheetWrapper from '@/js/components/sidebars/SidebarSheetWrapper';
import Breadcrumb from '@/js/components/Breadcrumb';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PartDetailsScreen2 from '@/js/screens/Buyer/Project/PartDetailsScreen2';

const steps = [
  { id: 1, label: 'Create Project' },
  { id: 2, label: 'Add Parts' },
];

const BuyerAddParts = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  var { projectId, projectName } = useParams();

  const [sectionId, setSectionId] = useState(2);

  return (
    <div className="font-roboto bg-backgroundGray min-h-[calc(100vh-70px)] relative">
      <div className="absolute left-20 top-3">
        <Breadcrumb
          steps={steps}
          className="bg text-sm w-full"
          currentStep={sectionId}
        />
      </div>
      <div className="grid grid-cols-customCP12 min-h-[calc(100vh-70px)]">
        <div className="lg:hidden col-span-12 p-4">
          <Drawer>
            <DrawerTrigger asChild>
              <Menu size={28} className="cursor-pointer mt-7 ml-5" />
            </DrawerTrigger>
            <DrawerContent>
              <div className="mx-auto w-full max-w-sm">
                <DrawerHeader>
                  <DrawerTitle>Menu</DrawerTitle>
                </DrawerHeader>
                <LeftSidebar role="buyer" />
                <DrawerClose asChild>
                  <Button variant="outline" className="w-full">
                    Close
                  </Button>
                </DrawerClose>
              </div>
            </DrawerContent>
          </Drawer>
        </div>

        {/* Desktop Sidebar */}
        <div className="hidden lg:block lg:col-span-1">
          <div className="side-menu h-full pt-5">
            <SidebarSheetWrapper role="buyer" />
          </div>
        </div>

        {/* Main Content */}
        <div className="col-span-11 mt-10 mb-4 mx-3 rounded-lg relative overflow-hidden">
          <h2 className="p-3 bg-white mb-4 rounded-lg font-semibold text-xl text-gray-800">
            Project - {projectName}
          </h2>
          <PartDetailsScreen2 />
        </div>
      </div>
    </div>
  );
};

export default BuyerAddParts;
